// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__Hdlz-","portalLogo":"COM001F1_portalLogo__8mJqi","infoBox":"COM001F1_infoBox__avIrF"};